import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ScreenshotIcon, EditIcon, SynopsisIcon } from "../../components-new/icons";
import HistoryIcon from "@mui/icons-material/History";
import EditTabContainer from "./EditTabContainer";
import Synopsis from "./Edit/Synopsis";
import { fetchResultInRecording } from "../../API/RecordingTableAPI";
import Screenshot from "./Edit/Screenshot";
import StepHistory from "./Edit/StepHistory";
import TabComponent from "../../components-new/common/TabComponent";
import MobileSynopsis from "../../components-new/common/MobileSynopsis";
import DivergenceAnalysis from "./Edit/DivergenceAnalysis";
import { useSelector } from "react-redux";
import ConfidenceScoreGraph from "./Edit/ConfidenceScoreGraph";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { getStepStatus } from "../../utils/helpers";
const EditTabs = ({ editItem, fromExcReports = false, initialTab = 0 }) => {
  const [valuesSavedResult, setValuesSavedResult] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const isMobile = useSelector((state) => state.authoringSlice.isMobile);
  const executionSelectedTestCase = useSelector((state) => state.executionSlice.selectedTestCase);
  const getResults = async (api_input) => {
    if (!api_input) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetchResultInRecording(api_input);
      if (response?.data) {
        if (response.status === 200) {
          if (response.data.message !== "fail") {
            setValuesSavedResult(Object.values(response.data));
          }
        }
      }
    } catch (error) {
      console.error("Error fetching results:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getResults(editItem?.Test_Case_Id || executionSelectedTestCase);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tabs = [
    {
      icon: <EditIcon />,
      label: "Edit",
      tooltip: "Edit step configuration, test data, and element details",
      content: <EditTabContainer item={editItem} isLoading={isLoading} />,
    },
    {
      icon: <ScreenshotIcon />,
      label: "Screenshot",
      tooltip: "View execution screenshots for this step",
      content: (
        <Screenshot
          currentEditItem={editItem}
          fromExcReports={fromExcReports}
          refreshedResults={valuesSavedResult}
        />
      ),
    },
    {
      icon: <SynopsisIcon />,
      label: "Synopsis",
      tooltip: "View step execution details including timing and status",
      content: isMobile ? (
        <MobileSynopsis
          currentEditItem={editItem}
          fromExcReports={fromExcReports}
          valuesSavedResult={valuesSavedResult}
        />
      ) : (
        <Synopsis
          currentEditItem={editItem}
          fromExcReports={fromExcReports}
          valuesSavedResult={valuesSavedResult}
        />
      ),
    },
    {
      icon: <ScreenshotIcon />,
      label: "Image Diff",
      tooltip: "Compare baseline and current screenshots with visual diff",
      content: (
        <Screenshot
          fromImageDiff={fromExcReports}
          currentEditItem={editItem}
          similarity={editItem?.similarity}
        />
      ),
    },
    {
      icon: <ShowChartIcon />,
      label: "Confidence Trend",
      tooltip: "View confidence score across recent runs for this step",
      content: <ConfidenceScoreGraph currentEditItem={editItem} />,
    },
    {
      icon: <HistoryIcon />,
      label: "Step History",
      tooltip: "View execution history and past failures for this step",
      content: <StepHistory currentEditItem={editItem} fromExcReports={fromExcReports} />,
    },
    {
      icon: <HistoryIcon />,
      label: "Divergence Analysis",
      tooltip: "Analyse divergence patterns for this step",
      content: <DivergenceAnalysis currentEditItem={editItem} />,
    },
  ];

  if (isLoading) {
    return <Box p={3}>Loading...</Box>;
  }

  return (
    <Box sx={{ width: "100%" }} mt={2.5} zIndex={100}>
      <TabComponent
        tabsMarginBottom={1.5}
        initialTab={initialTab}
        tabs={
          fromExcReports
            ? tabs.filter((item) => {
                if (item.label === "Edit") return false;
                if (item.label === "Step History") {
                  return getStepStatus(editItem)?.toUpperCase() === "FAIL";
                }
                if (item.label === "Divergence Analysis") {
                  return editItem?.divergentStep === true;
                }
                return true;
              })
            : tabs.filter((item) => item.label !== "Image Diff" && item.label !== "Step History" && item.label !== "Divergence Analysis" && item.label !== "Confidence Trend")
        }
      />
    </Box>
  );
};

export default EditTabs;
